import { Eye, UserMinus, RefreshCw, Download } from "lucide-react"
import type { TableAction, BulkAction } from "@shared/types/data-table"
import type { Enrollment } from "@shared/types/engagement.types"

interface EnrollmentActionHandlers {
  onViewDetails?: (enrollment: Enrollment) => void
  onSuspend?: (enrollment: Enrollment) => void
  onReactivate?: (enrollment: Enrollment) => void
  onBulkExport?: (ids: string[]) => void
  onBulkSuspend?: (ids: string[]) => void
}

export function getEnrollmentRowActions(config: EnrollmentActionHandlers): TableAction<Enrollment>[] {
  const actions: TableAction<Enrollment>[] = []

  if (config.onViewDetails) {
    actions.push({
      key: 'view-details',
      label: 'View Details',
      icon: <Eye className="h-4 w-4" />,
      onClick: config.onViewDetails,
    })
  }

  if (config.onSuspend) {
    actions.push({
      key: 'suspend',
      label: 'Suspend',
      icon: <UserMinus className="h-4 w-4" />,
      onClick: config.onSuspend,
      condition: (e) => e.status === 'active',
      variant: 'destructive',
    })
  }

  if (config.onReactivate) {
    actions.push({
      key: 'reactivate',
      label: 'Reactivate',
      icon: <RefreshCw className="h-4 w-4" />,
      onClick: config.onReactivate,
      condition: (e) => e.status === 'suspended' || e.status === 'opted_out',
    })
  }

  return actions
}

export function getEnrollmentHoverActions(config: EnrollmentActionHandlers): TableAction<Enrollment>[] {
  return config.onViewDetails ? [
    {
      key: 'view',
      label: 'View details',
      icon: <Eye className="h-4 w-4" />,
      onClick: (enrollment) => config.onViewDetails?.(enrollment),
    },
  ] : []
}

export function getEnrollmentBulkActions(config: EnrollmentActionHandlers = {}): BulkAction[] {
  const actions: BulkAction[] = []

  if (config.onBulkExport) {
    actions.push({
      key: 'export',
      label: 'Export Selected',
      icon: <Download className="h-4 w-4" />,
      onClick: config.onBulkExport,
    })
  }

  if (config.onBulkSuspend) {
    actions.push({
      key: 'suspend',
      label: 'Suspend Selected',
      icon: <UserMinus className="h-4 w-4" />,
      onClick: config.onBulkSuspend,
      variant: 'destructive',
    })
  }

  return actions
}
